import React, { useState } from "react";
import InputDropFile from "../../../../controls/InputDropFile";
import UploadProducts from "./UploadProducts";
import { action, API, controller } from "../../../../api/api";
import { ToFormData } from "../../../../hooks/Method";
import Processing from "../../../../layout/Processing";
import { Alert } from "../../../../layout";
import { useNavigate } from "react-router-dom";

const UploadFile = () => {
  const navigate = useNavigate();
  const [status, setStatus] = useState();
  const [values, setValues] = useState();
  const [fileName, setFileName] = useState("");
  const [alert, setAlert] = useState({
    isOpen: false,
    type: "",
    title: "",
    subTitle: "",
  });
  const [processing, setProcessing] = useState({
    show: false,
    title: "",
  });

  const handleFile = (e) => {
    const file = e.value[0];
    if (file) {
      setProcessing({
        show: true,
        title:
          "Hang tight — we're uploading your file. Larger files might take a bit longer.",
      });
      API(controller.Product + action.ValidateImportProduts).post(
        ToFormData({ file: file }),
        (res) => {
          setStatus(res.status);
          setValues([...res.result]);
          setFileName(file.name);
          setProcessing({ show: false });

          navigate("/products");
        }
      );
    }
  };

  const renderContent = () => {
    switch (status) {
      case 200:
        return (
          <>
            {!processing.show && (
              <UploadProducts
                {...{
                  values,
                  setValues,
                  setStatus,
                  fileName,
                  setProcessing,
                  setAlert,
                }}
              />
            )}
          </>
        );
      default:
        return (
          <>
            {!processing.show && (
              <InputDropFile
                name="file"
                onChange={handleFile}
                acceptFile={{
                  "text/csv": [".csv"],
                  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
                    [".xlsx"],
                }}
              />
            )}
          </>
        );
    }
  };

  return (
    <div className="w-full">
      {renderContent()}
      <Processing show={processing.show} title={processing.title} />
      {/* Alert  */}
      <Alert alert={alert} setAlert={setAlert} />
    </div>
  );
};

export default UploadFile;
